import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import PrismCol from '../GridElements/PrismCol';
import PrismCheckbox from '../../checkbox/prismCheckbox';

import CELL_PROP_TYPES from '../constants';

class SelectSell extends React.PureComponent {
    static propTypes = {
        ...CELL_PROP_TYPES,
        value: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.elementId = `row-select_${uuid()}`;
    }

    render() {
        const {
            value,
            className,
            extraProps
        } = this.props;

        const columnClassName = classNames(
            'prism-grid__body-column',
            'prism-grid__body-column_select',
            className
        );

        return (
            <PrismCol
                {...this.props}
                className={columnClassName}
            >
                <PrismCheckbox
                    id={this.elementId}
                    checkboxClassName="prism-grid__body-column_select-control"
                    checked={value}
                    {...extraProps}
                />
            </PrismCol>
        );
    }
}

export default SelectSell;
